import apiService from '@/services/apiService';

const actions = {
  getMyVoucherTabWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher-tab/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getMyVoucherTab({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`promo/voucher-tab/find-by-id/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postMyVoucherTab({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('promo/voucher-tab', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putMyVoucherTab({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`promo/voucher-tab/update/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteMyVoucherTab({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`promo/voucher-tab/delete/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  orderField({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`promo/voucher-tab/change-order/${payload.id}`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changeVoucherOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.put(`promo/voucher-tab/change-voucher-order/${payload.id}/voucher-order/${payload.voucher_order}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
};

export default actions;